module.exports = __webpack_public_path__ + "img/gmyb.057821fa.webp";